import { useEffect, useState } from "react"
import { arrowLeft, logo, unView, view } from "../assets/images/images"
import CheckInput from "../assets/images/CheckInput"
import { useLocation, useNavigate } from "react-router-dom";
import { validateEmail, validatePassword } from "../share/validation";
import { checkEmailAccountant, resetPasword, resetPaswordConfirm } from "../services/api/auth.service";
import { publish } from "../services/loadingServices/loading.service";
import { showApiError } from "../services/apiError";

const CreateAccountant = () => {
    const nav = useNavigate();
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const token: any = useLocation().pathname.split("/").pop();
    const [showPassword, setShowPassword] = useState<{ password: boolean; confirmPassword: boolean; }>({
        password: false,
        confirmPassword: false,
    });
    const location = useLocation();
    const [message, setMessage] = useState("")
    const [step, setStep] = useState<string>("1");
    const [errors, setErrors] = useState({
        password: "",
        confirmPassword: "",
    })
    const [formValues, setFormValues] = useState({
        password: "",
        confirmPassword: "",
    });
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value.trim() }));
        if (name === 'email') {
            if (!value) {
                setErrors(prev => ({ ...prev, email: 'Email is required' }));
            } else if (!validateEmail(value)) {
                setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }));
            } else {
                setErrors(prev => ({ ...prev, email: '' }));
            }
        }
        if (name === 'password') {
            const passwordError = validatePassword(value);
            setErrors(prev => ({ ...prev, password: passwordError }));
        }

        if (name === 'confirmPassword' || name === 'password') {
            const passwordValue = name === 'password' ? value : formValues.password;
            const confirmValue = name === 'confirmPassword' ? value : formValues.confirmPassword;
            if (confirmValue && passwordValue !== confirmValue) {
                setErrors(prev => ({ ...prev, confirmPassword: 'Passwords do not match' }));
            } else {
                setErrors(prev => ({ ...prev, confirmPassword: '' }));
            }
        }
    };
    const isFormStepTwo = () => {
        const { password, confirmPassword } = formValues;
        return password && confirmPassword && validatePassword(password) === '' && !errors.password && !errors.confirmPassword && password === confirmPassword;
    };

    const handleSubmitStepOne = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        publish('loading', true);
        const payload: any = {
            ...formValues,
            token: token
        }
        try {
            const response = await checkEmailAccountant(payload);
            if (response.data.success) {
                publish('loading', false);
                setMessage("Email verification sented, please check email !")
            }
        } catch (error: any) {
            publish('loading', false);
            showApiError(error, { language: window.languageContext?.language, setFieldErrors: (fe) => setErrors((prev: any) => ({ ...prev, ...fe })) });
        }
    }

    return (
        <>
            <div className="py-10 space-y-10 xl:w-[550px]  mx-auto">
                <img src={logo} className="" />
                <form className="w-full space-y-8" onSubmit={(e: any) => handleSubmitStepOne(e)}>
                    <div className="space-y-4">
                        <p className="text-[24px] text-main font-bold">Create Accountant</p>
                        <p className="text-[18px] text-main font-bold">Enter the password</p>
                    </div>
                    <div className="w-full space-y-2">
                        <p className="text-[18px] text-main font-bold no-select">Password</p>
                        <div className="relative">
                            <input
                                name="password"
                                value={formValues.password}
                                onChange={handleChange}
                                type={showPassword.password ? "text" : "password"}
                                className="text-[18px] placeholder:text-subtitle text-main font-bold border border-[#EBEBED] px-4 py-[14px] rounded-md outline-none focus-none bg-transparent w-full"
                            />
                            <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                <img
                                    src={showPassword.password ? unView : view}
                                    className="w-6 aspect-square cursor-pointer"
                                    onClick={() => { setShowPassword({ ...showPassword, password: !showPassword.password }) }}
                                />
                            </div>
                        </div>
                        {errors?.password.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.password}</p>}

                    </div>
                    <div className="w-full space-y-2">
                        <p className="text-[18px] text-main font-bold no-select">Confirm Password</p>
                        <div className="relative">
                            <input
                                name="confirmPassword"
                                value={formValues.confirmPassword}
                                onChange={handleChange}
                                type={showPassword.confirmPassword ? "text" : "password"}
                                className={`text-[18px] placeholder:text-subtitle text-main font-bold border  px-4 py-[14px]  rounded-md outline-none focus-none bg-transparent w-full ${errors?.confirmPassword.length ? "border-[#E40F03]" : "border-[#EBEBED]"} `}
                            />
                            <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                <img
                                    src={showPassword.confirmPassword ? unView : view}
                                    className="w-6 aspect-square cursor-pointer"
                                    onClick={() => { setShowPassword({ ...showPassword, confirmPassword: !showPassword.confirmPassword }) }}
                                />
                            </div>
                        </div>
                        {errors?.confirmPassword.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.confirmPassword}</p>}
                    </div>
                    <button disabled={!isFormStepTwo()} className={`w-full h-10 text-base font-bold flex items-center justify-center rounded-md ${isFormStepTwo() ? "bg-[#3ABFC3] text-main" : "bg-[#D8F2F2] text-[#C6C6C6]"}`}>
                        Create Account
                    </button>
                    <div className="flex items-center justify-center gap-x-3 text-base font-bold cursor-pointer" onClick={() => { nav("/login") }}>
                        <img src={arrowLeft} />
                        <p className="cursor-pointer text-main" >Back to Sign In</p>
                    </div>
                </form>

            </div>
            {
                showSuccessPopup && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                            <h2 className="text-2xl font-bold text-main mb-4">Success!</h2>
                            <p className="text-main mb-6">Your account has been created successfully.</p>
                            <button
                                onClick={() => nav('/login')}
                                className="w-full bg-[#3ABFC3] text-main font-bold py-3 rounded-md"
                            >
                                Continue to Sign in
                            </button>
                        </div>
                    </div>
                )
            }
        </>
    )
}
export default CreateAccountant